/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {
    Badge,
    ButtonBase,
    Collapse,
    Drawer,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    Typography
} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import {Close, LocalOffer, Menu, Search, ShoppingCartOutlined} from '@mui/icons-material'
import {useContext, useEffect, useState} from "react";
import {CATEGORIAS, REDESCLARAS, SECCIONES} from "../../Constantes";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import {useNavigate} from "react-router";
import {irUrl} from "../../Utilidades/irUrl";
import {contexApp} from "../../App";
import {useCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useCarritoLateral";
import {useFuncionesCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useFuncionesCarritoLateral";

const BarraCell = ({negro, mostrar = true}) => {
    const cData = useContext(contexApp)
    const navigate = useNavigate()
    const {Carrito, abrir} = useCarritoLateral()
    const {productos} = useFuncionesCarritoLateral()
    const [open, setOpen] = useState(false)
    const [palabra, setPalabra] = useState('')
    const [subCategorias, setSubCategorias] = useState([])
    const [categorias, setCategorias] = useState([])
    const [openSubCats, setOpenSubCats] = useState(false)
    const [openColecciones, setOpenColecciones] = useState(false)
    const [colecciones, setColecciones] = useState([])

    const sePresiono = (e) => {

        if (e.key === 'Enter') {
            setOpen(false)
            navigate('/Resultados/palabra/' + palabra)
        }
    }


    const irRuta = (ruta) => {

        if (ruta === SECCIONES[0]) {
            navigate(`/Home`)
            setTimeout(() => {
                scrolearAComponente(SECCIONES[0])
            }, 500)

        } else {
            navigate(`/${ruta}`)
        }
    }

    useEffect(() => {

        if (cData.subCategorias) {
            setSubCategorias(cData.subCategorias)
        }

        if (cData.colecciones) {
            setColecciones(cData.colecciones)
        }


    }, [cData])
    return (
        <Grid
            container
            justifyContent={'space-between'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: negro ? '#000' : '#00000000', px: 3, py: mostrar ? 3 : 2}}
        >

            <Carrito/>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <img
                    onClick={() => navigate('/Home')}
                    src={logo} width={130} height={'auto'} style={{marginTop: -5}}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-end'}
                alignItems={'flex-start'}
                size={{xs: 6, sm: 6, md: 6}}
                spacing={1}
            >

                <IconButton
                    onClick={() => abrir()}
                >
                    <Badge badgeContent={productos.length} color="secondary"
                           anchorOrigin={{horizontal: 'left', vertical: 'top'}}>
                        <ShoppingCartOutlined sx={{fill: '#fff'}}/>
                    </Badge>

                </IconButton>

                <IconButton
                    onClick={() => setOpen(true)}
                >
                    <Menu sx={{fill: '#fff'}}/>
                </IconButton>

            </Grid>


            <Drawer open={open} onClose={() => setOpen(false)}
                    anchor={'right'} slotProps={{
                paper: {
                    sx: {backgroundColor: '#000'}
                }
            }}
            >

                <Grid container size={{xs: 12, ms: 12, md: 12}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <Close sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, ms: 12, md: 12}}
                      sx={{width: 300, p: 2, marginTop: 2, justifyContent: 'center'}}>


                    <TextField
                        label={'Búsqueda por producto'}
                        fullWidth={false}
                        size={'small'}
                        variant={'outlined'}
                        color={'action'}
                        focused
                        value={palabra}
                        onChange={e => setPalabra(e.target.value)}
                        onKeyDown={(e) => sePresiono(e)}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Search
                                            onClick={() => {
                                                setOpen(false)
                                                navigate('/Resultados/palabra/' + palabra)
                                            }}
                                            sx={{fill: '#ffffff90', cursor: 'pointer'}}/>
                                    </InputAdornment>
                                ),
                                disableUnderline: true,
                                sx: {color: '#fff'}
                            },
                            inputLabel: {
                                sx: {marginLeft: -1, color: '#fff'}
                            }
                        }

                        }
                        sx={{mb: 2}}
                    />

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', marginTop: 2}}>
                        <ButtonBase
                            onClick={() => {
                                setOpen(false)
                                setTimeout(() => {
                                    irRuta('Home')
                                }, 500)
                            }}

                        >
                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    textAlign: 'center'
                                }}>HOME</Typography>
                        </ButtonBase>
                    </Grid>

                    <Grid container size={{xs: 12, ms: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpenSubCats(!openSubCats)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>CATEGORÍAS</Typography>
                            </ButtonBase>

                            <Collapse in={openSubCats}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{py: 3}}
                                >


                                    {CATEGORIAS.map((it, index) => {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'center', marginTop: 2}}>
                                                <ButtonBase
                                                    onClick={() => {
                                                        setOpen(false)
                                                        setTimeout(() => {
                                                            navigate('/DetalleCat/' + it.nombre.toUpperCase())
                                                        }, 800)

                                                    }
                                                    }

                                                >
                                                    <Typography
                                                        sx={{
                                                            color: '#fff',
                                                            fontSize: 20,
                                                            fontWeight: 600,
                                                            textAlign: 'center',
                                                            borderBottom: 1,
                                                        }}>{it.nombre}</Typography>
                                                </ButtonBase>
                                            </Grid>
                                        )
                                    })}

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mb: 4}}>

                                    </Grid>

                                    {subCategorias.map((it, index) => {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'center', marginTop: 2}}>
                                                <ButtonBase
                                                    onClick={() => {
                                                        setOpen(false)
                                                        setTimeout(() => {
                                                            navigate('/Resultados/subCat/' + it.nombre)
                                                        }, 800)

                                                    }
                                                    }

                                                >
                                                    <Typography
                                                        sx={{
                                                            color: '#fff',
                                                            fontSize: 20,
                                                            fontWeight: 600,
                                                            textAlign: 'center'
                                                        }}>{it.nombre}</Typography>
                                                </ButtonBase>
                                            </Grid>
                                        )
                                    })}


                                </Grid>
                            </Collapse>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => setOpenColecciones(!openColecciones)}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>COLECCIONES</Typography>
                            </ButtonBase>

                            <Collapse in={openColecciones}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{py: 3}}
                                >


                                    {colecciones.map((it, index) => {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'center', marginTop: 2}}>
                                                <ButtonBase
                                                    onClick={() => {
                                                        setOpen(false)
                                                        setTimeout(() => {
                                                            navigate('/DetalleCol/' + it.id)
                                                        }, 800)

                                                    }
                                                    }

                                                >
                                                    <Typography
                                                        sx={{
                                                            color: '#fff',
                                                            fontSize: 20,
                                                            fontWeight: 600,
                                                            textAlign: 'center',
                                                            borderBottom: 1,
                                                        }}>{it.nombre}</Typography>
                                                </ButtonBase>
                                            </Grid>
                                        )
                                    })}


                                </Grid>
                            </Collapse>

                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        irRuta('Nosotras')
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>NOSOTRAS</Typography>
                            </ButtonBase>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        navigate('/Todos')
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>TODOS LOS PRODUCTOS</Typography>
                            </ButtonBase>
                        </Grid>


                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', marginTop: 2}}>
                        <ButtonBase
                            onClick={() => {
                                setOpen(false)
                                setTimeout(() => {
                                    navigate('/Descuentos')
                                }, 500)
                            }}

                        >
                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    textAlign: 'center'
                                }}>
                                <span><LocalOffer sx={{mt: 0, mb: -0.7, pr: 0.7, width: 24, height: 24}}/></span>
                                SALE
                            </Typography>
                        </ButtonBase>
                    </Grid>

                    <Grid container size={{xs: 12, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 40}}>
                        <img src={logo} width={150} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 10, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 2}}>
                        {REDESCLARAS.map((item, index) => {
                            return (
                                <Grid container size={{xs: 3, ms: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <IconButton
                                        onClick={() => irUrl(item.url)}
                                    >
                                        <img src={item.icono} width={32} height={'auto'}/>
                                    </IconButton>
                                </Grid>
                            )
                        })}
                    </Grid>


                </Grid>

            </Drawer>

        </Grid>
    )

}
export default BarraCell